const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20friendly%20and%20approachable%20expression%2C%20modern%20casual%20style%2C%20high%20quality%20headshot%20photography%2C%20warm%20color%20tones&width=120&height=120&seq=avatar-1&orientation=squarish',
    name: '追剧小达人',
    time: '2小时前',
    content: '香蕉影视真的是我用过最好用的追剧平台！加载速度超快，画质清晰到每一根头发丝都看得见。最关键是全集免费，再也不用到处找资源了，强烈安利给所有追剧姐妹！',
    likes: 2356,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20young%20Chinese%20man%20with%20confident%20expression%2C%20clean%20minimalist%20style%2C%20soft%20studio%20lighting%20on%20neutral%20beige%20background%2C%20modern%20professional%20headshot%2C%20warm%20and%20approachable%20look%2C%20high%20quality%20portrait%20photography&width=120&height=120&seq=avatar-2&orientation=squarish',
    name: '剧荒拯救者',
    time: '5小时前',
    content: '以前看剧总是要忍受各种弹窗广告和漫长的加载，自从换了香蕉影视才知道什么叫「追剧自由」。1080P蓝光画质配上秒开的加载速度，周末一口气刷完一整部剧不要太爽！',
    likes: 1892,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20Chinese%20woman%20in%20her%20twenties%20with%20gentle%20smile%2C%20warm%20and%20natural%20portrait%20photography%2C%20soft%20diffused%20lighting%2C%20cream%20backdrop%2C%20casual%20elegant%20style%2C%20friendly%20and%20genuine%20expression%2C%20high%20quality%20headshot&width=120&height=120&seq=avatar-3&orientation=squarish',
    name: '深夜追剧人',
    time: '12小时前',
    content: '作为海外党，之前追国内剧各种卡顿心累。朋友推荐了香蕉影视之后简直打开了新世界的大门！海外访问也超级流畅，而且字幕清晰、更新及时，终于可以和国内同步追剧了。',
    likes: 1520,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">剧迷热评</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">听听追剧同好们怎么说，每一句都是真实用户的肺腑之言</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsData.map((comment, i) => (
            <div key={i} className="p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <div className="font-medium text-foreground-900 text-sm">{comment.name}</div>
                  <div className="text-foreground-400 text-xs">{comment.time}</div>
                </div>
              </div>
              <p className="text-foreground-600 text-xs leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-foreground-400 text-xs">
                <i className="ri-heart-line text-primary-500"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}